import { render, staticRenderFns } from "./Nicknames-Single-User.vue?vue&type=template&id=a27f503a"
import script from "./Nicknames-Single-User.js?vue&type=script&lang=js&external"
export * from "./Nicknames-Single-User.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports